import React from 'react'

const Rocket = ({
  className = '',
  width = '155',
  height = '170',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 155 170'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        d='M68.5223 29.4986L77.0602 19.8936C84.3196 11.7267 93.4137 5.37691 103.602 1.3609C112.704 -2.22679 122.316 5.23597 121.018 14.882L120.916 15.6391C119.486 26.2576 115.679 36.4252 109.776 45.393L102.501 56.4453L70.5619 104.814L29.6138 72.3393L68.5223 29.4986Z'
        fill='#648CFE'
      />
      <mask
        id='mask0_5732_130288'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='29'
        y='0'
        width='93'
        height='105'
      >
        <path
          d='M68.5223 29.4986L77.0602 19.8936C84.3196 11.7267 93.4137 5.37691 103.602 1.3609C112.704 -2.22679 122.316 5.23597 121.018 14.882L120.916 15.6391C119.486 26.2576 115.679 36.4252 109.776 45.393L102.501 56.4453L70.5619 104.814L29.6138 72.3393L68.5223 29.4986Z'
          fill='#648CFE'
        />
      </mask>
      <g mask='url(#mask0_5732_130288)'>
        <path
          opacity='0.6'
          d='M126.159 24.8956C120.98 4.3481 101.349 -1.63032 92.181 -2.05108L105.134 -13.7463L135.859 -12.0556C134.784 8.82297 131.338 45.4432 126.159 24.8956Z'
          fill='#2538BF'
        />
        <ellipse
          opacity='0.6'
          cx='26.131'
          cy='17.7674'
          rx='26.131'
          ry='17.7674'
          transform='matrix(0.783515 0.621373 -0.625997 0.779826 46.9922 50.6895)'
          fill='#2538BF'
        />
        <path
          opacity='0.2'
          d='M64.149 86.2962C82.5315 68.0258 108.664 24.23 119.432 4.61591L120.162 0.20942C125.623 -12.0337 133.468 -28.0134 121.162 6.01314C108.856 40.0397 85.9105 74.6088 74.8539 86.3772C64.3741 94.8048 45.7664 104.567 64.149 86.2962Z'
          fill='white'
        />
      </g>
      <ellipse
        cx='26.131'
        cy='17.7674'
        rx='26.131'
        ry='17.7674'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 42.126 56.752)'
        fill='#A8CCF8'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625996 0.779826 39.4814 70.7051)'
        fill='#2538BF'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625996 0.779826 54.9404 71.875)'
        fill='#2538BF'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 59.3984 86.748)'
        fill='#2538BF'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 44.5137 84.8643)'
        fill='#2538BF'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625996 0.779826 38.7871 71.5713)'
        fill='#648CFE'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625996 0.779826 54.2451 72.7412)'
        fill='#648CFE'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 58.7031 87.6143)'
        fill='#648CFE'
      />
      <ellipse
        cx='7.22774'
        cy='4.91439'
        rx='7.22774'
        ry='4.91439'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 43.8184 85.7305)'
        fill='#648CFE'
      />
      <path
        d='M23.5689 60.6307C36.6067 41.3595 55.0846 39.0428 62.6938 40.2932C59.4202 43.7401 51.9651 51.5757 48.3332 55.3427C43.7933 60.0514 38.5964 58.9515 38.1321 58.5833C37.6677 58.215 34.9754 56.8353 23.5689 60.6307Z'
        fill='#0E72ED'
      />
      <path
        d='M81.8767 108.463C97.8863 91.5489 96.0564 73.1268 93.1402 66.03C90.4857 69.9679 84.4546 78.9327 81.5656 83.2889C77.9545 88.7342 80.1873 93.5265 80.6517 93.8948C81.116 94.263 83.0673 96.5659 81.8767 108.463Z'
        fill='#0E72ED'
      />
      <ellipse
        cx='11.6756'
        cy='9.43893'
        rx='11.6756'
        ry='9.43893'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 95.333 11.7861)'
        fill='#2538BF'
      />
      <ellipse
        cx='11.6756'
        cy='10.5494'
        rx='11.6756'
        ry='10.5494'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 97.418 9.18945)'
        fill='white'
      />
      <ellipse
        cx='9.45165'
        cy='8.53999'
        rx='9.45165'
        ry='8.53999'
        transform='matrix(0.783515 0.621373 -0.625997 0.779826 98.085 11.9102)'
        fill='#2538BF'
      />
      <mask
        id='mask1_5732_130288'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='91'
        y='15'
        width='19'
        height='19'
      >
        <ellipse
          cx='9.45166'
          cy='8.53999'
          rx='9.45166'
          ry='8.53999'
          transform='matrix(0.783515 0.621373 -0.625997 0.779826 98.085 11.9102)'
          fill='#648CFE'
        />
      </mask>
      <g mask='url(#mask1_5732_130288)'>
        <ellipse
          cx='9.45165'
          cy='8.53999'
          rx='9.45165'
          ry='8.53999'
          transform='matrix(0.783515 0.621373 -0.625996 0.779826 97.3896 12.7764)'
          fill='#648CFE'
        />
      </g>
      <mask
        id='mask2_5732_130288'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='90'
        y='16'
        width='19'
        height='19'
      >
        <ellipse
          cx='9.45165'
          cy='8.53999'
          rx='9.45165'
          ry='8.53999'
          transform='matrix(0.783515 0.621373 -0.625996 0.779826 97.3896 12.7764)'
          fill='#648CFE'
        />
      </mask>
      <g mask='url(#mask2_5732_130288)'>
        <g opacity='0.4'>
          <rect
            width='12.3692'
            height='47.9118'
            transform='matrix(0.228896 0.973451 -0.974063 0.226278 126.511 4.54395)'
            fill='white'
          />
          <rect
            width='2.47383'
            height='47.9118'
            transform='matrix(0.228896 0.973451 -0.974063 0.226277 129.908 18.9932)'
            fill='white'
          />
        </g>
      </g>
      <path
        d='M41.2653 79.158C38.1445 76.4992 36.2497 79.5273 35.6924 81.3736C35.1351 82.6844 23.9893 94.6677 18.9737 100.207C13.9581 105.746 12.2862 107.962 13.9581 109.624C15.6299 111.285 14.5153 114.609 13.4008 115.717C12.2862 116.824 3.36958 124.579 1.69774 129.011C-4.98972 155.156 9.68554 166.492 17.8591 168.893H95.8795C100.784 167.563 102.753 166.492 103.124 166.123C108.697 155.045 105.353 152.275 97.5513 143.966C90.1938 136.131 78.232 138.243 71.9161 141.197C66.1574 143.412 54.3058 147.068 52.9683 143.966C51.2964 140.089 52.9683 137.319 61.3276 131.78C66.2317 123.361 57.0551 117.194 51.8537 115.163C49.253 114.239 42.4913 111.285 36.2497 106.854C27.7789 97.9912 34.9494 89.1286 39.5934 85.805C41.4511 84.6972 44.3861 81.8168 41.2653 79.158Z'
        fill='#648CFE'
      />
      <path
        opacity='0.4'
        d='M41.2653 79.158C38.1445 76.4992 36.2497 79.5273 35.6924 81.3736C35.1351 82.6844 23.9893 94.6677 18.9737 100.207C13.9581 105.746 12.2862 107.962 13.9581 109.624C15.6299 111.285 14.5153 114.609 13.4008 115.717C12.2862 116.824 3.36958 124.579 1.69774 129.011C-4.98972 155.156 9.68554 166.492 17.8591 168.893H95.8795C100.784 167.563 102.753 166.492 103.124 166.123C108.697 155.045 105.353 152.275 97.5513 143.966C90.1938 136.131 78.232 138.243 71.9161 141.197C66.1574 143.412 54.3058 147.068 52.9683 143.966C51.2964 140.089 52.9683 137.319 61.3276 131.78C66.2317 123.361 57.0551 117.194 51.8537 115.163C49.253 114.239 42.4913 111.285 36.2497 106.854C27.7789 97.9912 34.9494 89.1286 39.5934 85.805C41.4511 84.6972 44.3861 81.8168 41.2653 79.158Z'
        fill='#E7F1FD'
      />
      <path
        d='M63.4035 93.0056C60.2827 90.3468 58.3879 93.3749 57.8306 95.2213C57.2733 96.532 46.1275 108.515 41.1119 114.055C36.0963 119.594 34.4244 121.809 36.0963 123.471C37.7681 125.133 36.6536 128.456 35.539 129.564C34.4244 130.672 35.6918 124.579 34.02 129.01C27.3325 155.155 42.0078 166.492 50.1814 168.892H128.202C133.106 167.563 135.075 166.492 135.446 166.123C141.019 155.044 137.676 152.275 129.874 143.966C122.516 136.131 110.554 138.242 104.238 141.196C98.4797 143.412 86.628 147.068 85.2905 143.966C83.6187 140.089 85.2905 137.319 93.6499 131.78C98.554 123.36 79.1933 131.041 73.9919 129.01C71.3912 128.087 64.6295 125.133 58.3879 120.702C49.9171 111.839 57.0876 102.976 61.7316 99.6527C63.5893 98.5449 66.5243 95.6644 63.4035 93.0056Z'
        fill='#648CFE'
      />
      <path
        opacity='0.4'
        d='M63.4035 93.0056C60.2827 90.3468 58.3879 93.3749 57.8306 95.2213C57.2733 96.532 46.1275 108.515 41.1119 114.055C36.0963 119.594 34.4244 121.809 36.0963 123.471C37.7681 125.133 36.6536 128.456 35.539 129.564C34.4244 130.672 35.6918 124.579 34.02 129.01C27.3325 155.155 42.0078 166.492 50.1814 168.892H128.202C133.106 167.563 135.075 166.492 135.446 166.123C141.019 155.044 137.676 152.275 129.874 143.966C122.516 136.131 110.554 138.242 104.238 141.196C98.4797 143.412 86.628 147.068 85.2905 143.966C83.6187 140.089 85.2905 137.319 93.6499 131.78C98.554 123.36 79.1933 131.041 73.9919 129.01C71.3912 128.087 64.6295 125.133 58.3879 120.702C49.9171 111.839 57.0876 102.976 61.7316 99.6527C63.5893 98.5449 66.5243 95.6644 63.4035 93.0056Z'
        fill='#E7F1FD'
      />
      <path
        d='M57.984 80.2654C54.8632 77.6066 52.9684 80.6347 52.4112 82.4811C51.8539 83.7918 40.708 95.7752 35.6924 101.314C30.6768 106.854 29.0049 109.069 30.6768 110.731C32.3487 112.393 31.2341 115.716 30.1195 116.824C29.0049 117.932 20.0883 125.687 18.4165 130.118C11.729 156.263 26.4043 167.6 34.5779 170H112.598C117.502 168.671 119.471 167.6 119.843 167.231C125.416 156.152 122.072 153.383 114.27 145.074C106.913 137.238 94.9508 139.35 88.6348 142.304C82.8762 144.52 71.0245 148.176 69.687 145.074C68.0152 141.196 69.687 138.427 78.0463 132.888C82.9505 124.468 73.7738 118.301 68.5724 116.27C65.9718 115.347 59.21 112.393 52.9684 107.961C44.4977 99.0987 51.6681 90.236 56.3122 86.9125C58.1698 85.8046 61.1049 82.9242 57.984 80.2654Z'
        fill='#E7F1FD'
      />
    </svg>
  )
}

export default Rocket
